const educations={
    LESSON_NUMBER_TITLE:"جلسه ",
    TAG:"تگ ها: ",

}

export default educations;